<template>
    <v-card class="panelBlock map-widget businesses-map">
        <v-flex class="ypoMap">
            <ypo-map :mapList="mapList" :centerTo="centerTo"/>
        </v-flex>
    </v-card>
</template>

<script>
    import YpoMap from '../YpoMap/YPOMap';

    export default {
        name: "BusinessesMap",
        components: {
            YpoMap,
        },
        props: {
            centerTo: {
                type: Object,
                required: false,
            },
            mapList: {
                type: Array,
                required: false,
            },
        },
        data() {
            return {
            };
        },
        computed: {
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .businesses-map {
        .ypoMap {
            .vue-map-container {
                height: 700px;
                @include breakpoint(xs) {
                    height: 250px;
                }
            }
        }
    }
</style>
